import React from "react";

const SavePlusIcon = ({color = "#39AC73", isInteractive = false, ...rest}) => {
	return (
		<div
			style={{
				display: "inline-flex",
				alignItems: "center",
				justifyContent: "center",
				transform: isInteractive ? "scale(1)" : undefined,
				transition: isInteractive ? "transform 0.2s" : undefined,
				cursor: isInteractive ? "pointer" : undefined,
			}}
			onMouseEnter={(e) => {
				if (isInteractive) {
					e.currentTarget.style.transform = "scale(1.1)";
				}
			}}
			onMouseLeave={(e) => {
				if (isInteractive) {
					e.currentTarget.style.transform = "scale(1)";
				}
			}}
			{...rest}
		>
			<svg
				xmlns="http://www.w3.org/2000/svg"
				width="20"
				height="20"
				viewBox="0 0 20 20"
				fill="none"
				{...rest}
			>
				<mask
					id="mask0_134_38006"
					style={{maskType: "alpha"}}
					maskUnits="userSpaceOnUse"
					x="0"
					y="0"
					width="20"
					height="20"
				>
					<rect width="20" height="20" fill="#D9D9D9" />
				</mask>
				<g mask="url(#mask0_134_38006)">
					<path
						d="M9.21011 14.0398H10.7898V10.7898H14.0398V9.21014H10.7898V5.96014H9.21011V9.21014H5.96011V10.7898H9.21011V14.0398ZM10.0057 18.1694C8.87809 18.1694 7.81822 17.9568 6.82611 17.5315C5.834 17.1063 4.966 16.5217 4.22213 15.7778C3.47825 15.034 2.89369 14.1663 2.46844 13.1747C2.04319 12.1832 1.83057 11.1218 1.83057 9.99045C1.83057 8.85913 2.04319 7.80089 2.46844 6.81572C2.89369 5.83056 3.47825 4.96603 4.22213 4.22216C4.966 3.47828 5.83371 2.89372 6.82523 2.46847C7.81678 2.04322 8.8782 1.8306 10.0095 1.8306C11.1408 1.8306 12.1991 2.04322 13.1842 2.46847C14.1694 2.89372 15.0339 3.47828 15.7778 4.22216C16.5217 4.96603 17.1062 5.83212 17.5315 6.82041C17.9567 7.80869 18.1694 8.86663 18.1694 9.99424C18.1694 11.1219 17.9567 12.1817 17.5315 13.1738C17.1062 14.166 16.5217 15.034 15.7778 15.7778C15.0339 16.5217 14.1678 17.1063 13.1795 17.5315C12.1913 17.9568 11.1333 18.1694 10.0057 18.1694ZM9.99996 16.4402C11.7922 16.4402 13.3137 15.8149 14.5643 14.5643C15.8149 13.3137 16.4402 11.7923 16.4402 9.99999C16.4402 8.20773 15.8149 6.68629 14.5643 5.43568C13.3137 4.18508 11.7922 3.55978 9.99996 3.55978C8.2077 3.55978 6.68626 4.18508 5.43565 5.43568C4.18505 6.68629 3.55975 8.20773 3.55975 9.99999C3.55975 11.7923 4.18505 13.3137 5.43565 14.5643C6.68626 15.8149 8.2077 16.4402 9.99996 16.4402Z"
						fill={color}
					/>
				</g>
			</svg>
		</div>
	);
};

export default SavePlusIcon;
